export default __webpack_public_path__ + "static/media/addressList.2a0835e4.svg";